import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { QuoteRequiredData } from '../models/quote.required.data';
import { ApiAddressService } from './api.address.service';
import { LoginService } from './login.service';
import { SharedFunctionService } from './shared.function.service';
import { DevTools } from './dev.tools';
import { ApiService } from './api.service';
import { GeneralResponseMessage } from '../models/messages/general.response.message';
import { HttpRequestUrl } from '../models/http.request.models/request.url';

@Injectable({
  providedIn: 'root',
})
export class DataLoaderService {
  private http = inject(HttpClient);
  private apiAddressService = inject(ApiAddressService);
  private loginService = inject(LoginService);
  private sharedFunction = inject(SharedFunctionService);
  private apiService = inject(ApiService);

  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  // load json file
  loadRequiredJsonFile(): Observable<QuoteRequiredData> {
    let url: string = this.apiAddressService.getRequiredJsonUrl() + '?d=' + new Date().getTime();

    return this.http.get<QuoteRequiredData>(url, this.httpOptions).pipe(
      tap((t) => new DevTools().log(`loadRequiredJsonFile`, null)),
      catchError(this.sharedFunction.handleError('loadRequiredJsonFile', null))
    );
  }

  getRequiredDataFromServer(currentRequiredData: QuoteRequiredData, callback: (requiredData: QuoteRequiredData) => void) {
    // load qpr version.
    this.apiService.callApiWithoutAuth<QuoteRequiredData>('', this.apiAddressService.getQprAndQeVersionUrl(), (response) => {
      if (response && response.QeVersion && response.QprVersion) {
        currentRequiredData.QeVersion = response.QeVersion;
        currentRequiredData.QprVersion = response.QprVersion;
        currentRequiredData.SelectOptions = response.SelectOptions;
      }
      callback(currentRequiredData);
    });
  }

  uploadFile(file: File, url: HttpRequestUrl, callback: (response: GeneralResponseMessage) => void) {
    // build form data with selected file.
    let formData = new FormData();
    formData.append('file', file);

    // call api.
    this.apiService.callApi<GeneralResponseMessage>(formData, url, (response) => {
      callback(response);
    });
  }
}
